<template>
<div class='vx-col w-full mt-4'>
    <div class="popup">
        <vs-popup title="Crear evaluacion de repaso" :active.sync="popupRepaso">
            <div class="eval-creada">
                <h4>¿De cuántas unidades deseas crear tu evaluación para el libro {{ libroSelect.nombrelibro }}? </h4>
                <!-- <div class="inline" v-for="(item,index) in unidades" :key="index">
                    <vs-checkbox class="m-2 inline-grid " vs-type="success" :vs-value="item.id" v-model="unidadesSelect"> {{ item.nombre }}</vs-checkbox>
            </div> -->
                <small>Puedes elegir una o varias unidades para armar tu evaluación de repaso.</small>
                <v-select class="mt-4 mb-4 w-full" multiple v-model="unidadesSelect" :options="unidades" :reduce="unidades => unidades.id" label="nombre" />
                <!-- {{ unidadesSelect }} -->
                <div class="cant-preguntas">
                    <h4>¿Cuántas preguntas deseas usar?</h4>
                    <v-select class="mt-4 mb-4 w-full" v-model="cant_preguntasSelect" :options="cant_preguntas" :reduce="cant_preguntas => cant_preguntas" label="nombre" />
                    <!-- {{ cant_preguntasSelect }} -->
                </div>
                <div class="espaciado m-4">
                    <vs-button class="w-full" v-if="unidadesSelect.length>0" @click="f_crear_evaluacion_repaso()">Crear repaso</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>

    <!--LISTADO DE REPASO-->
    <div v-if="menu == 0">
        <section v-if="!verLista">
            <vx-card class="m-2">
                <!-- <div class="bg-repaso"></div> -->
                <h4>
                    ¡Bienvenidos! Espero que todos estén listos y entusiasmados. Hoy vamos a dedicar tiempo a repasar y consolidar lo que hemos aprendido hasta ahora. Este repaso de evaluación nos ayudará a estar mejor preparados para los próximos desafíos. ¡Empecemos!
                </h4>
            </vx-card>
            <vx-card class="m-2" v-if="filtrados.length > 0">
                <div class="col-12 m-2">
                    Selecciona el libro que deseas realizar el repaso de la evaluación.
                </div>
                <div class="col-12">
                    <v-select class="mb-3 w-full" v-model="libroSelect" :options="filtrados" :reduce="filtrados => filtrados" label="nombrelibro" />
                </div>
                <div v-if="Object.keys(libroSelect).length != 0">
                    <vs-button @click="f_abrir_modal()">Crear evaluación de repaso</vs-button>
                </div>
            </vx-card>
            <vx-card class="m-2" v-if="filtrados.length == 0">
                <h4 class="col-12">
                    No hay libros que mostrar. Asegúrate de que tengas cursos agregados y/o libros registrados.
                </h4>
            </vx-card>
        </section>
        <!--table de listado de repaso-->
        <vx-card>
            <vs-table max-items="10" search pagination :data="arrayListadoRepaso">
                <template slot="header">
                    <vs-chip color="primary">Cantidad: <b> {{ arrayListadoRepaso.length }}</b></vs-chip>
                </template>
                <template slot="thead">
                    <vs-th>Libro</vs-th>
                    <vs-th>Unidades</vs-th>
                    <vs-th>Preguntas</vs-th>
                    <vs-th>Acciones</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            {{data[indextr].libro.nombrelibro}}<br>
                        </vs-td>
                        <vs-td>
                            {{data[indextr].unidades}}<br>
                        </vs-td>
                        <vs-td>
                            {{data[indextr].cant_preguntas}}<br>
                        </vs-td>
                        <vs-td>
                            <vs-button @click="repasoSelected=tr;menu = 1;"><i class="fa-solid fa-file-invoice"></i> Realizar intento</vs-button>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>
    </div>
    <!--evaluacion de repaso-->
    <vx-card v-if="menu == 1">
        <vs-button @click="menu = 0" class="my-2" ><i class="fa-solid fa-arrow-left"></i></vs-button>
        <ScreenEvaluacionRepasoVue :repasoSelected="repasoSelected" />
    </vx-card>
</div>
</template>

<script>
import vSelect from 'vue-select'
import GeneralMixin from '@/mixins/GeneralMixin';
const ScreenEvaluacionRepasoVue = () => import('./repasoEstudiante/ScreenEvaluacionRepaso.vue');
export default {
    mixins: [GeneralMixin],
    components: {
        'v-select': vSelect,
        ScreenEvaluacionRepasoVue
    },
    data() {
        return {
            unidadesSelect: [],
            unidades: [{
                    'id': 1,
                    'nombre': 'Unidad 1',
                },
                {
                    'id': 2,
                    'nombre': 'Unidad 2',
                },
                {
                    'id': 3,
                    'nombre': 'Unidad 3',
                },
                {
                    'id': 4,
                    'nombre': 'Unidad 4',
                },
                {
                    'id': 5,
                    'nombre': 'Unidad 5',
                },
                {
                    'id': 6,
                    'nombre': 'Unidad 6',
                },
                {
                    'id': 7,
                    'nombre': 'Unidad 7',
                },
                {
                    'id': 8,
                    'nombre': 'Unidad 8',
                },
                {
                    'id': 9,
                    'nombre': 'Unidad 9',
                },
                {
                    'id': 10,
                    'nombre': 'Unidad 10',
                },
            ],
            cant_preguntas: [{
                    'id': 10,
                    'nombre': '10'
                },
                {
                    'id': 20,
                    'nombre': '20'
                },
                {
                    'id': 0,
                    'nombre': 'Todas las disponibles'
                }
            ],
            cant_preguntasSelect: {},
            libros: [],
            cursos: [],
            usuario: [],
            miusuario: '',
            filtrados: [],
            agrupado: [],
            verLista: false,
            libroSelect: [],
            popupRepaso: false,
            preg_repaso_disponibles: 0,
            arrayListadoRepaso: [],
            menu: 0,
            repasoSelected: '',
        };
    },
    created() {
        this.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
        this.miusuario = this.usuario
    },
    mounted() {
        let me = this;
        // this.$store.commit('TOGGLE_REDUCE_BUTTON', true)
        this.getLibros();
        me.getListadoRepaso();
    },
    beforeDestroy() {
        // this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
    },
    methods: {
        getListadoRepaso() {
            let me = this;
            me.$vs.loading()
            this.$http.get(this.$server_url + `estudianteRepaso?getRepasoListado=1&estudiante=${me.usuario.idusuario}&periodo=${localStorage.periodo_id}`)
                .then(function (response) {
                    me.arrayListadoRepaso = response.data;
                    me.$vs.loading.close()
                })
                .catch(function () {
                    me.$vs.loading.close()
                })
        },
        async getLibros() {
            let me = this;
            me.$vs.loading()
            let region = localStorage.region
            this.$http.get(this.$server_url + 'codigos_libros_estudiante/' + me.usuario.idusuario + '/' + me.usuario.institucion_idInstitucion + '/' + localStorage.periodo_id + '/' + region)
                .then(function (response) {
                    me.libros = response.data.libros
                    // console.log('response cursos', response.data.libros);
                    me.getCurso();
                    me.$vs.loading.close()
                })
                .catch(function () {
                    me.$vs.loading.close()
                })
        },
        getCurso() {
            let me = this;
            me.$vs.loading()
            this.$http.get(this.$server_url + 'estudianteCurso?idusuario=' + me.usuario.idusuario)
                .then(function (response) {
                    // console.log('response cursos', response.data);
                    me.cursos = response.data;
                    me.agruparCursosYLibros()
                    me.$vs.loading.close()
                })
                .catch(function () {
                    me.$vs.loading.close()

                })
        },
        agruparCursosYLibros() {
            //filtrar idlibro unicos
            let me = this;
            me.agrupado = me.libros.concat(me.cursos);
            me.filtrados = me.agrupado.filter(
                (obj, index, self) =>
                index === self.findIndex((t) => t.idlibro === obj.idlibro)
            );
            console.log(me.filtrados)
        },
        f_ver_lista(item) {
            let me = this;
            me.verLista = true;
            me.libroSelect = item;
            console.log('libro select', item);
        },
        f_abrir_modal() {
            let me = this;
            console.log(me.libroSelect)
            me.popupRepaso = true;
        },
        f_crear_evaluacion_repaso() {
            let me = this;
            console.log('crear evaluacion repaso')
            let datos_enviar = new FormData();
            datos_enviar.append('id_libro', me.libroSelect.idlibro);
            datos_enviar.append('cant_preguntas', me.cant_preguntasSelect.id);
            datos_enviar.append('id_usuario', me.usuario.idusuario);
            datos_enviar.append('unidades', me.unidadesSelect.join(','));
            datos_enviar.append('id_periodo', localStorage.periodo_id);
            me.$http.post(me.$server_url + 'creaEvaluacionRepaso', datos_enviar)
                .then(function () {
                    // console.log('response crear evaluacion repaso', response.data);
                    me.f_notificaciones('Repaso creado correctamente');
                    me.popupRepaso = false;
                    me.getListadoRepaso();
                })
                .catch(() => {
                    console.error('Error al crear evaluación repaso')
                    me.popupRepaso = false;
                });
        }
    },
};
</script>

<style scoped>
.bg-repaso {
    background-image: url('../../../assets/images/evaluacion/bg-repaso.svg');
    /* src\assets\images\evaluacion\bg-repaso.jpg */
    background-repeat: no-repeat;
    background-size: cover;
}

.grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
}

.card {
    border-radius: 15px;
    /* width: 25%; */
    background: #fff;
    border: 1px solid #ccc;
    /* margin-bottom: 50px; */
    transition: 0.3s;

}

.card-header {
    border-radius: 15px 15px 0 0;
    text-align: center;
    /* padding: 50px 10px; */
    padding: 15px;
    /* height: 50px; */
    background: linear-gradient(to bottom, #964343, #ff4b2b);
    color: #fff;
    font-size: 1.5em;
}

.card-body {
    padding: 30px 20px;
    text-align: center;
    font-size: 18px;
}

.card-body .btn {
    display: block;
    color: #fff;
    text-align: center;
    background: linear-gradient(to top, #a56161, #8a716d);
    text-decoration: none;
    margin-top: 30px;
    padding: 10px 5px;
    transition: 0.3s;
}

.card-body .btn:hover {
    transform: scale(1.1);
}

.card:hover {
    transform: scale(1.1);
    box-shadow: 0 0 40px -10px rgba(0, 0, 0, 0.25);
}

.espaciado {
    min-height: 200px;
}
</style>
